<template>
  <q-dialog ref="dialogRef"
            @hide="onDialogHide">
    <q-card :style="style">
      <q-card-section class="q-pa-lg">
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none q-pl-lg q-pr-lg q-pb-lg">
        {{body}}
      </q-card-section>

      <q-card-section class="q-pa-lg">
        <q-input v-model="userResponse"
                 type="textarea"
                 :label="promptLabel"
                 :maxlength="maxLength"
                 :counter="counter" />
      </q-card-section>

      <q-card-actions align="right"
                      class="q-pa-lg">
        <q-btn flat
               color="primary"
               :label="cancelLabel"
               @click="onCancelClick" />
        <q-btn color="primary"
               :label="okLabel"
               @click="onOKClick"
               :disable="!isValid" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, computed } from 'vue';
import { useDialogPluginComponent } from 'quasar';

export default {
  props: {
    okLabel: {
      type: String,
      default: 'Confirm',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    promptLabel: {
      type: String,
      default: undefined,
    },
    title: String,
    body: String,
    style: String,
    validation: {
      type: Function,
      default(response) {
        // we want to validate the response is not empty
        return response !== '';
      },
    },
    maxLength: {
      type: Number,
      default: undefined,
    },
    counter: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits,
  ],
  setup(props) {
    // REQUIRED; must be called inside of setup()
    const {
      dialogRef, onDialogHide, onDialogOK, onDialogCancel,
    } = useDialogPluginComponent();

    const userResponse = ref('');
    const isValid = computed(() => props.validation(userResponse.value));

    return {
      // This is REQUIRED;
      // Need to inject these (from useDialogPluginComponent() call)
      // into the vue scope for the vue html template
      dialogRef,
      onDialogHide,

      onOKClick() {
        if (isValid.value) {
          onDialogOK(userResponse);
        }
      },
      onCancelClick: onDialogCancel,
      userResponse,
      isValid,
    };
  },
};
</script>
